var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160531",
    "data-name": "Group 160531",
    transform: "translate(-592 -160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1910",
    "data-name": "Rectangle 1910",
    width: 16,
    height: 16,
    transform: "translate(592 160)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock-closed-outline",
    transform: "translate(501 130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M179.63,36.874v-2.1a1.816,1.816,0,0,0-3.63,0v2.1",
    transform: "translate(-78.185)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1919",
    "data-name": "Rectangle 1919",
    width: 7,
    height: 6,
    rx: 1,
    transform: "translate(96 37)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectLockIcon);
export default __webpack_public_path__ + "static/media/MultiselectLock-icon.030f2d33409a6d7ba3717c8e334b0d9a.svg";
export { ForwardRef as ReactComponent };